import Swiper from "swiper/bundle";

const FinishesSlider = () => {
  const finishesSliders = [...document.querySelectorAll(".finishes__slider")];
  const sliderBlock =   [...document.querySelectorAll(".slider-block")]; 
  const initializeSlider = () => {
    sliderBlock.forEach((finishesSlider) => {
      const pagination = finishesSlider.querySelector(".slider__pagination");
      const btns = finishesSlider.querySelector(".slider__btns");
      const nextBtn = finishesSlider.querySelector(".finishes__slider-btn-next");
      const prevBtn = finishesSlider.querySelector(".finishes__slider-btn-prev");
      const slide = finishesSlider.querySelector(".finishes__slider");
      const slides = [...finishesSlider.querySelectorAll('.swiper-slide')];

      const minSlidesForMobile = 1;
      const minSlidesForTablet = 2;
      const minSlidesForDesktop = 3;

      const shouldInitializeSlider = (window.innerWidth >= 1024 && slides.length > minSlidesForDesktop) ||
                                     (window.innerWidth < 1024 && window.innerWidth >= 768 && slides.length > minSlidesForTablet) ||
                                     (window.innerWidth < 768 && slides.length > minSlidesForMobile);

      if (!shouldInitializeSlider) {
        if (btns && pagination) {
          btns.classList.add("d-none");
          pagination.classList.add("d-none");
        }
      } else {
        if (btns && pagination) {
          btns.classList.remove("d-none");
          pagination.classList.remove("d-none");
        }

        const finishesCarousel = new Swiper(slide, {
          slidesPerView: "auto",
          spaceBetween: 16,
          allowTouchMove: false,
          pagination: {
            el: pagination,
            clickable: true,
          },
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            0: {
             
              spaceBetween: 20,
              allowTouchMove: true, 
            },
            768: {
             
              spaceBetween: 20,
            },
            1024: {
             
              spaceBetween: 24,
            },
            1441: {
            
              spaceBetween: 32,
            },
          },
          on: {
            init: function () {
              const compareImage = document.querySelector(".compare-image2 img");
              if (compareImage) {
                const width = compareImage.offsetWidth;
                const foregroundImage = document.querySelector(".foreground-picture-container img");
                if (foregroundImage) {
                  foregroundImage.style.width = `${width}px`;
                }
              }

              const finishingOptionsSliders = document.querySelectorAll(".finishes-options__slider");
              if (finishingOptionsSliders.length > 0) {
                finishingOptionsSliders.forEach((slider) => {
                  new Swiper(slider, {
                    spaceBetween: 0,
                    navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                      el: ".swiper-pagination",
                      dynamicBullets: true,
                    },
                  });
                });
              }
            }
          }
        });
      }
    });
  };

  initializeSlider();

  window.addEventListener('resize', () => {
    finishesSliders.forEach((finishesSlider) => {
      const swiperInstance = finishesSlider.swiper;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }
    });
    initializeSlider();
  });
};

export default FinishesSlider;

